import { render, staticRenderFns } from "./EmailStatistics.vue?vue&type=template&id=7e95a332&scoped=true&"
import script from "./EmailStatistics.vue?vue&type=script&lang=js&"
export * from "./EmailStatistics.vue?vue&type=script&lang=js&"
import style0 from "./EmailStatistics.vue?vue&type=style&index=0&id=7e95a332&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e95a332",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCol,VRow})
